export default function RatingIcon({ className="", onClick=null }) {
  return (
    <>
      <svg className={className} onClick={onClick} viewBox="0 0 700 700" xmlns="http://www.w3.org/2000/svg">
        <path d="m348.98 164.12 63.95 126.86 140.75 19.22-100.87 100.03 25.21 139.81-126.3-65.03-125.18 67.18 22.82-140.22-102.57-98.29 140.4-21.63 61.79-127.93m-42.59-20.57-50.97 105.54-115.83 17.84-80.61 12.42c-5.77 0.89-8.02 8.01-3.8 12.05l58.89 56.43 84.62 81.08-18.83 115.68-13.1 80.51c-0.94 5.76 5.14 10.1 10.28 7.34l71.87-38.57 103.27-55.42 176.71 90.98c5.19 2.67 11.19-1.77 10.16-7.51l-14.47-80.26-20.8-115.34 83.22-82.52 57.92-57.43c4.15-4.11 1.78-11.19-4.01-11.98l-196.92-26.9-52.76-104.65-36.72-72.83c-2.63-5.21-10.09-5.15-12.63 0.11l-35.47 73.45z"/>
      </svg>
    </>
  );
}